import * as Sentry from '@sentry/react'
import { useAtom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'

import { MODULE_NAME } from '../../config/constants/module-name'

const ActiveModuleStorage = createJSONStorage<MODULE_NAME>(() => localStorage)

const ActiveModuleAtom = atomWithStorage<MODULE_NAME>(
    '@dostavkee/active-module',
    MODULE_NAME.dostavkee,
    ActiveModuleStorage,
    {
        getOnInit: true,
    }
)

export const useActiveModule = () => {
    const [activeModule, setActiveModule] = useAtom(ActiveModuleAtom)

    const setActiveModuleHandler = (name: MODULE_NAME) => {
        try {
            if (!Object.values(MODULE_NAME).includes(name)) {
                throw new Error(`Invalid module name: ${name}`)
            }

            setActiveModule(name)
        } catch (error) {
            Sentry.captureException(error)
        }
    }

    return {
        activeModule,
        setActiveModule: setActiveModuleHandler,
    }
}
